var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",class:_vm.classes},[_c('span',{staticClass:"logo__main"},[_vm._v("Sneakbox")]),_c('span',{staticClass:"logo__sub"},[_vm._v("bêta")])])}
var staticRenderFns = []

export { render, staticRenderFns }